import '@/libs/promise/index'

const currentDate = '3.11.2021'

import '@/libs/disable_extension_warning/index'
import '@/libs/vendor/index'

import { isGispOrigin } from '@/libs/env/index'
import { getInstance } from '@frontend/tiny_router'

const router = getInstance({
  prefix: isGispOrigin ? '/etpfs' : '',
})

/* tslint:disable:no-var-requires max-line-length */
router.addRoutes([
  {
    actions: async () => new (await import('@/views/application/bank_guarantees/index.ts')).BankGuaranteesExtraPage(),
    name: 'BankGuaranteesExtraPage',
    pattern: '/bank_guarantees/',
  },
  {
    actions: async () => new (await import('@/views/application/bank_guarantees/show/index.ts')).BankGuaranteesLanding(),
    name: 'BankGuaranteesLanding',
    pattern: '/bank_guarantees/:id',
  },
  {
    actions: async () => new (await import('@/views/application/contacts/index.ts')).ContactsPage(),
    name: 'ContactsPage',
    pattern: '/contacts/',
  },
  {
    actions: async () => new (await import('@/views/application/info_item/articles/show/index.ts')).InfoItemArticle(),
    name: 'InfoItemArticle',
    pattern: '/articles/:id/',
  },
  {
    actions: async () => new (await import('@/views/application/knowledge/categories/question/index.ts')).KnowledgeQuestionPage(),
    name: 'KnowledgeQuestionPage',
    pattern: '/knowledge/categories/:category/questions/:question',
  },
  {
    actions: async () => new (await import('@/views/application/knowledge/index.ts')).KnowledgePage(),
    name: 'KnowledgePage',
    pattern: '/knowledge/categories/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/absolyut_strahovanie/insurance_funds/index.ts')).LeadsAbsolyutInsuranceFunds(),
    name: 'LeadsAbsolyutInsuranceFunds',
    pattern: '/absolyut_strahovanie/insurance_funds/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/absolyut_strahovanie/lost_work/index.ts')).LeadsAbsolyutLostWork(),
    name: 'LeadsAbsolyutLostWork',
    pattern: '/absolyut_strahovanie/lost_work/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/amulex/lawyer/index.ts')).LeadsAmulexlawyer(),
    name: 'LeadsAmulexlawyer',
    pattern: '/amulex/lawyer/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/auto_assistance/rat/index.ts')).LeadsAutoAssistanceRat(),
    name: 'LeadsAutoAssistanceRat',
    pattern: '/auto_assistance/rat/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/etp_gpb/accounting/index.ts')).LeadsEtpGpbAccounting(),
    name: 'LeadsEtpGpbAccounting',
    pattern: '/etp_gpb/accounting/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/etp_gpb/bank_guarantee/index.ts')).LeadsEtpGpbBankGuarantee(),
    name: 'LeadsEtpGpbBankGuarantee',
    pattern: '/etp_gpb/bank_guarantee/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/etp_gpb/business_lawyer/index.ts')).LeadsEtpGpbBusinessLawyer(),
    name: 'LeadsEtpGpbBusinessLawyer',
    pattern: '/etp_gpb/business_lawyer/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/etp_gpb/cardberry/index.ts')).LeadsEtpGpbCardberry(),
    name: 'LeadsEtpGpbCardberry',
    pattern: '/etp_gpb/cardberry/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/etp_gpb/edo/index.ts')).LeadsEtpGpbEdo(),
    name: 'LeadsEtpGpbEdo',
    pattern: '/etp_gpb/edo/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/etp_gpb/factoring/index.ts')).LeadsEtpGpbFactoring(),
    name: 'LeadsEtpGpbFactoring',
    pattern: '/etp_gpb/factoring/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/etp_gpb/insurance_msb/index.ts')).LeadsEtpGpbInsuranceMsb(),
    name: 'LeadsEtpGpbInsuranceMsb',
    pattern: '/etp_gpb/insurance_msb/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/etp_gpb/leasing/index.ts')).LeadsEtpGpbLeasing(),
    name: 'LeadsEtpGpbLeasing',
    pattern: '/etp_gpb/leasing/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/etp_gpb/logistics/index.ts')).LeadsEtpGpbLogistics(),
    name: 'LeadsEtpGpbLogistics',
    pattern: '/etp_gpb/logistics/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/etp_gpb/suppliers/index.ts')).LeadsEtpGpbSuppliers(),
    name: 'LeadsEtpGpbSuppliers',
    pattern: '/etp_gpb/factoring/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/etp_gpb/tender_loan/index.ts')).LeadsEtpGpbTenderLoan(),
    name: 'LeadsEtpGpbTenderLoan',
    pattern: '/etp_gpb/tender_loan/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/etp_gpb/training/index.ts')).LeadsEtpGpbTraining(),
    name: 'LeadsEtpGpbTraining',
    pattern: '/etp_gpb/training/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/gpb/exchange/index.ts')).LeadsGpbExchange(),
    name: 'LeadsGpbExchange',
    pattern: '/gpb/exchange/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/gpb/leasing/index.ts')).LeadsGpbLeasing(),
    name: 'LeadsGpbLeasing',
    pattern: '/gpb/leasing/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/gpb/obligations/index.ts')).LeadsGpbObligations(),
    name: 'LeadsGpbObligations',
    pattern: '/gpb/obligations/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/gpb_am/pif/index.ts')).LeadsGpbAmPif(),
    name: 'LeadsGpbAmPif',
    pattern: '/gpb_am/pif/leads',
  },
  {
    actions: async () => new (await import('@/views/application/leads/logistics_trust/custom/index.ts')).LeadsLogisticsTrustCustom(),
    name: 'LeadsLogisticsTrustCustom',
    pattern: '/logistics_trust/custom/leads',
  },
  {
    actions: async () => new (await import('@/views/application/leads/potok/company_loan/index.ts')).LeadsPotokCompanyLoan(),
    name: 'LeadsPotokCompanyLoan',
    pattern: '/potok/company_loan/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/sogaz/without_risk_for_business/index.ts')).LeadsSogazWrb(),
    name: 'LeadsSogazWrb',
    pattern: '/sogaz/without_risk_for_business/leads',
  },
  {
    actions: async () => new (await import('@/views/application/leads/sravniru/kasko/index.ts')).LeadsSravniruKasko(),
    name: 'LeadsSravniruKasko',
    pattern: '/sravniru/kasko/leads',
  },
  {
    actions: async () => new (await import('@/views/application/leads/sravniru/osago/index.ts')).LeadsSravniruOsago(),
    name: 'LeadsSravniruOsago',
    pattern: '/sravniru/osago/leads',
  },
  {
    actions: async () => new (await import('@/views/application/leads/sravniru/travel_insurance/index.ts')).LeadsSravniruTravelInsurance(),
    name: 'LeadsSravniruTravelInsurance',
    pattern: '/sravniru/travel_insurance/leads',
  },
  {
    actions: async () => new (await import('@/views/application/leads/vtb/health_manage/index.ts')).LeadsVtbHealthManage(),
    name: 'LeadsVtbHealthManage',
    pattern: '/vtb/health_manage/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/leads/vtb/pediatrician/index.ts')).LeadsVtbPediatrician(),
    name: 'LeadsVtbPediatrician',
    pattern: '/vtb/pediatrician/leads/',
  },
  {
    actions: async () => new (await import('@/views/application/offer_requests/leads/new/index.ts')).OfferRequestsLeadsNew(),
    name: 'OfferRequestsLeadsNew',
    pattern: '/offer_requests/leads/new/',
  },
  {
    actions: async () => new (await import('@/views/application/offers/partnership/new/index.ts')).OffersIndex(),
    name: 'OffersIndex',
    pattern: '/partnership/offers/new/',
  },
  {
    actions: async () => new (await import('@/views/application/products/index.ts')).ProductsPage(),
    name: 'ProductsPage',
    pattern: '/',
  },
  {
    actions: async () => new (await import('@/views/application/products/underwriting/index.ts')).ProductsUnderwriting(),
    name: 'ProductsUnderwriting',
    pattern: '/products/underwriting/',
  },
])
/* tslint:enable:no-var-requires max-line-length */

router.resolve(`${window.location.pathname}${window.location.search}${window.location.hash}`).then((route) => {
  // console.log('resolved', route)
}, (err) => {
  // console.log(err)
})

import('@/behaviour/index.ts')
